import type { User } from "@/types";

import { BaseApi } from "./base.api";

class AuthApi extends BaseApi {
  /**
   * Joriy foydalanuvchi. 401 — kirilmagan; bu xato emas, holat, shuning
   * uchun toast ko'rsatilmaydi.
   */
  me() {
    return this.request<User>("/auth/me", { skipErrorToast: [401, 403] });
  }

  logout() {
    return this.request<void>("/auth/logout", { method: "POST" });
  }
}

export const authApi = new AuthApi();
